module.exports = "pegasus/assets/5px.png";